import { render, staticRenderFns } from "./SectionTimeline.vue?vue&type=template&id=c085f34e&scoped=true&"
import script from "./SectionTimeline.vue?vue&type=script&lang=js&"
export * from "./SectionTimeline.vue?vue&type=script&lang=js&"
import style0 from "./SectionTimeline.vue?vue&type=style&index=0&id=c085f34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c085f34e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
